import { defineMessages } from 'react-intl'

export const auditHeaderMessages = defineMessages({
  audit: {
    id: 'auditHeaderMessages.audit',
    description: "Audit page's main header Title",
    defaultMessage: 'Audit',
  },
  refresh: {
    id: 'auditHeaderMessages.refresh',
    description: "Audit's page button text to refresh Autdit results",
    defaultMessage: 'Refresh',
  },
})
